<template>
    <div>
        <template v-if="list.desc == 'Hari'">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Day</th>
                    <th>Working Day</th>
                    <th>Holiday</th>
                    <th>Note</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="data in list.data">
                    <tr :key="data.date">
                        <td>{{data.date}}</td>
                        <td>{{data.name}}</td>
                        <td>
                            <template v-if="data.working_day">
                                <i class="fa fa-check-circle text-success"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-times-circle text-danger"></i>
                            </template>
                        </td>
                        <td>
                            <template v-if="data.holiday">
                                <i class="fa fa-check-circle text-success"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-times-circle text-danger"></i>
                            </template>
                        </td>
                        <td>

                        </td>
                    </tr>
                </template>
            </tbody>
            
        </table>
        </template>
        <template v-else>
            <table class="table table-bordered">
                <thead>
                    <th>No</th>
                    <th>User Id</th>
                    <th>Name</th>
                    <th>Dept</th>
                    <th>Contract Until</th>
                    <th>Status</th>
                    <th>Note</th>
                </thead>
                <tbody>
                    <template v-for="(item, index ) in list.data">
                        <tr :key="item.user_id">
                            <td>{{index + 1}}</td>
                            <td>{{item.user_id}}</td>
                            <td>{{item.user_fulname}}</td>
                            <td>{{item.dept_name}}</td>
                            <td>{{item.contract_until}}</td>
                            <td>{{item.contract}}</td>
                            <td>{{item.contract_note}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: {
                data: []
             }
        }
    },
    created () {
        this.list = this.listData
    },
    props: {
        listData: {
            type: Object,
            default: () => {
                data: []
            }
        }
    },
    watch: {
        listData () {
            this.list = this.listData
        }
    },
}
</script>